import React, { useEffect, useMemo } from 'react';
import { AdminContentBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import AppBarCMS from '../../../../basic/Navigation/AppBarCMS/AppBarCMS';
import RoomForm from './RoomForm.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Form from '../../../../antd/form/Form/Form';
import {
  useGetRoomDetailQuery,
  useSaveRoomMutation,
} from '../../../../../redux/services/rooms';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import { useGetDepartmentsQuery } from '../../../../../redux/services/departments';

const RoomsEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  const { data: roomDetail, isLoading: isLoadingRoom } = useGetRoomDetailQuery(
    id,
    { skip: !isEdit },
  );

  const { data: departments, isLoading: isLoadingDepartments } =
    useGetDepartmentsQuery();

  const [saveRoom, { isSuccess: isSaveSuccess }] = useSaveRoomMutation();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsRooms);
    }
  }, [isSaveSuccess]);

  const pageTitle =
    (isCreate && t('Pridanie miestnosti')) || t('Úprava miestnosti');

  useEffect(() => {
    document.title = pageTitle + ' - FRI CMS';
  }, []); // Runs on mount

  const normalizedRoomDetail = roomDetail
    ? {
        ...roomDetail,
        department_room:
          roomDetail.department_room === 'Yes' || roomDetail.department_room === true,
      }
    : null;

  const initials = {
    title: undefined,
    department_id: undefined,
    department_room: false,
    ...normalizedRoomDetail,
  };

  const departmentsForSelect = useMemo(() => {
    if (!departments) return [];
    return departments.map((department) => ({
      label: department.title_sk,
      value: department.id,
    }));
  }, [departments]);

  if ((isLoadingRoom || isLoadingDepartments || !roomDetail) && isEdit) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsRooms}
        backUrlTooltip={t('Miestnosti')}
        permissionsBasic={'rooms'}
      />
      <div style={{ margin: '10px' }}>
        <AdminContentBlock
          icon="fa fa-sticky-note-o"
          link={routes.cmsRooms}
          title={pageTitle}
        >
          <Form
            initialValues={initials}
            onFinish={(values) => {
              if (isCreate) {
                saveRoom({ data: values });
              } else {
                saveRoom({
                  data: values,
                  id: roomDetail.id,
                });
              }
            }}
          >
            <RoomForm departments={departmentsForSelect} />
          </Form>
        </AdminContentBlock>
      </div>
    </>
  );
};

export default RoomsEdit;
